<template>
  <div class="check-agree_wrapper">
    <van-checkbox checked-color="#FF6534" icon-size="14px" label-disabled v-bind="$attrs" v-on="$listeners">
      <div class="text">
        我已阅读并同意
        <template v-for="(item, index) in agreeList">
          <span :key="index" @click="handleClick(item, index)" id="agreeclick">《{{ item.title }}》{{ hasChar(index, agreeList) }} </span>
        </template>
      </div>
    </van-checkbox>

    <!-- 入网协议弹窗 -->
    <van-popup get-container="#app" position="bottom" class="contentPopup" v-model="showAgreement" v-if="showAgreement">
      <showAgreementDom :name="certName" @cancelPopup="showAgreement = false"></showAgreementDom>
    </van-popup>
    <!-- 收集客户信息公告弹窗 -->
    <van-popup get-container="#app" :style="{ backgroundColor: 'transparent', width: '376px' }" v-model="showCustomer" v-if="showCustomer">
      <showInfoGongGao @cancelPopup="showCustomer = false" v-show="showCustomer" />
    </van-popup>
    <!-- 宝宝树零时增加 -->
    <van-popup get-container="#app" :style="{ backgroundColor: 'transparent', width: '376px' }" v-model="showCustomer2" v-if="showCustomer2">
      <showInfoGongGao-bbt @cancelPopup="showCustomer2 = false" v-show="showCustomer2" />
    </van-popup>
    <van-popup get-container="#app" :style="{ backgroundColor: 'transparent', width: '376px' }" v-model="showCustomer3" v-if="showCustomer3">
      <showInfoGongGao-fwb @cancelPopup="showCustomer3 = false" :agreement="agreementObj" v-show="showCustomer3" />
    </van-popup>
    <van-popup get-container="#app" position="bottom" class="contentPopup" v-model="showCustomer4" v-if="showCustomer4">
      <showInfoGongGaoBottom @cancelPopup="showCustomer4 = false" :agreement="agreementObj" v-show="showCustomer4" />
    </van-popup>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import showInfoGongGao from '@/components/showInfoGongGao.vue'
import showInfoGongGaoBbt from '@/components/showInfoGongGao-bbt.vue'
import showInfoGongGaoFwb from '@/components/showInfoGongGao-fwb.vue'
import showAgreementDom from '@/components/showAgreementDom'
import showInfoGongGaoBottom from '@/components/showInfoGongGao-bottom'

import { TOGGLE_AGREEMENT } from '@/utils/popup'
import showModulesMixin from '@/mixins/showModules'
import { mobileProtocolApi } from '@/api'
import AgreementConfig, { urlBefore, agreement } from '@/utils/agreeConfig'
export default {
  name: 'CheckAgree',
  inject: [TOGGLE_AGREEMENT],
  inheritAttrs: false,
  props: {
    type: {
      type: Number,
      default: 0,
    },
    province: {
      type: Object,
      default: () => ({}),
    },
    certName: {
      type: String,
      default: () => '',
    },
  },
  components: {
    showAgreementDom,
    showInfoGongGao,
    showInfoGongGaoBbt,
    showInfoGongGaoFwb,
    showInfoGongGaoBottom,
  },
  mixins: [showModulesMixin],
  data() {
    return {
      agreementObj: {},
      innerProvince: null,
      userName: '',
      showAgreement: false,
      showCustomer: false,
      showCustomer2: false,
      showCustomer3: false, // 电信富文本。临时起名 优化像以后所有卡走富文本传输
      showCustomer4: false, //
    }
  },
  computed: {
    ...mapGetters(['channel']),
    ...mapState({
      cardId: ({ public: { cardId } }) => {
        return cardId
      },
    }),
    agreeList() {
      // type = 1 联通
      // type = 2 移动
      let resp = []
      if (this.isShouldDisplay('22')) {
        //宝宝树协议临时处理
        resp = Object.freeze(agreement.special)
        return resp
      } else {
        if (this.type === 1) {
          resp = Object.freeze(agreement.unicom)
        } else if (this.type === 2) {
          if (this.province && this.province.text == '浙江省') {
            resp = [
              {
                title: '入网告知书',
                key: '入网告知书',
              },
              ...Object.freeze(Object.freeze(agreement.move)),
            ]
          } else {
            resp = Object.freeze(Object.freeze(agreement.move))
          }
        } else if (this.type === 3) {
          resp = Object.freeze(Object.freeze(agreement.telecom))
        }
        return resp
      }
    },
  },
  watch: {
    province: {
      deep: true,
      handler(val) {
        this.innerProvince = val
      },
    },
  },

  methods: {
    hasChar(index, list) {
      if (index === list.length - 1) {
        return ''
      }
      return '、'
    },
    async handleClick(item, idx) {
      const vm = this
      const key = item.key
      let url, html
      if (this.isShouldDisplay('22')) {
        //宝宝树协议临时处理
        this.showCustomer2 = true
        return
      }
      if (this.type === 1) {
        if (key == '实名制公告') {
          this.agreementObj = agreement.unicom[idx]
          this.showCustomer3 = true
          return
        } else {
          key == '联通入网协议' ? (this.showAgreement = true) : (this.showCustomer = true)
          return
        }

        //   url = AgreementConfig[key]
        //   if (key === '联通入网协议') {
        //     url += `?name=${vm.certName || 'XXX'}`
        //  //   console.log(url)
        //   }
      } else if (this.type === 3) {
        this.agreementObj = agreement.telecom[idx]
        this.showCustomer4 = true

        return
      } else {
        const { province } = vm
        if (key === '中国移动用户入网协议') {
          const { code, data } = await mobileProtocolApi({
            cardType: this.cardId,
            channel: this.channel,
            provinceCode: province.provinceId || province.id || '',
          })
          if (code == 200) html = data
        } else if (key === '关于客户个人信息收集和使用规则的公告') {
          if (this.province == '浙江省') {
            this.agreementObj = agreement.move[idx - 1]
          } else {
            this.agreementObj = agreement.move[idx]
          }
          this.showCustomer4 = true
          return
        } else {
          url = AgreementConfig[key]
        }
      }
      const params = { title: item.title, url, html, key }
      vm[TOGGLE_AGREEMENT](params)
    },
  },
}
</script>
<style lang="scss" scoped>
.check-agree_wrapper {
  margin-top: 11px;
  .text {
    margin-left: 3px;
    font-size: 12px;
    font-weight: 400;
    color: #303030;
    line-height: 1.5;
    span {
      color: #fc6a1d;
    }
  }
}
.contentPopup {
  background-color: transparent !important;
  height: 100%;
  max-height: none;
  width: 10rem !important;
  left: auto !important;
  @media screen and (min-width: 500px) {
    width: 500px !important;
  }
}
</style>
